<template>
  <!-- Wrapper -->
  <div id="wrapper" class="wrapper">

    <!-- header Area-->
    <header-com></header-com>
    <!--// header Area-->

    <!-- Page Conttent -->
    <main class="page-content">

      <router-view></router-view>

      <!-- Features Area -->
      <features></features>
      <!--// Features Area -->
      <!-- Newsletter & Brand Logos Area -->

      <!--// Newsletter & Brand Logos Area -->
    </main>

    <!-- Footer Area -->
    <footer-com></footer-com>
    <!--// Footer Area -->

  </div>
  <!--// Wrapper -->
</template>

<script>
  import headerCom from '@/components/header-com'
  import heroArea from '@/components/hero-area'
  import features from '@/components/features'
  import footerCom from '@/components/footer-com'
  import newsletter from '@/components/newsletter'
  import quick from '@/components/quick'
  import {main} from './main'
  export default {
    name: "Layout",
    components:{
      headerCom,heroArea,features,footerCom,newsletter,quick
    },
    mounted:function() {
    }
  }


</script>

<style scoped>

</style>
